export default function BrandMark({ tag, compact = false, className = "" }) {
  return (
    <span className={`flex flex-col leading-none ${className}`} data-testid="brand-mark">
      <span className={`font-display font-semibold tracking-tight text-zinc-100 ${compact ? "text-base" : "text-lg"}`}>
        Forward <span className="text-amber-400">Exspansion</span>
      </span>
      <span className="mt-1 text-[9px] font-mono-d tracking-[0.32em] uppercase text-zinc-500">
        Solutions{tag ? ` · ${tag}` : ""}
      </span>
    </span>
  );
}
